import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIntegrationsState } from "./integrations.t";
import { IYoutubeState } from "./Youtube/youtube.t";

const initialState: IIntegrationsState = {
    youtube: {
        isInitStarted: false,
        isInited: false,
    }
}

const integrationsSlice = createSlice({
    name: 'integrations',
    initialState,
    reducers: {
        setYoutubeConfigAction(state, action: PayloadAction<Partial<IYoutubeState>>) {
            state.youtube = {
                ...state.youtube,
                ...action.payload,
            }
        }
    }
});

export const {
    setYoutubeConfigAction,
} = integrationsSlice.actions;

export default integrationsSlice.reducer;
